import React, { useState, useEffect } from 'react';
import { RcFile } from 'antd/es/upload/interface';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../../routes';
import { ApplicationState } from '../../../../../store';
import { FABRICATION_ORDER_INITIAL_STATE } from '../../../../../store/ducks/fabrication-purchase-order';
import { updateFabricationPurchaseOrderSettings } from '../../../../../store/ducks/fabrication-purchase-order/actions';
import { addToast } from '../../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../../store/ducks/toast/types';
import { EPurchaseRoutes } from '../../../../Purchase/purchase.routes';
import NewProject from './NewProjectModal';
import UploadProjectsContainer from './UploadProjectsContainer';
import { getTaggingInformationScreen } from '../../../../../utils/Tagging';
import { formatTaggingString } from '../../../../../utils/formatStrings';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import RevisionOfProject from './RevisionOfProjectModal';
interface IUploadProjectsProps {
  updateProjectsTable: () => void;
  handleExistingProject: (filename: string) => void;
}

const UploadProjects: React.FC<IUploadProjectsProps> = ({
  updateProjectsTable,
  handleExistingProject
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { screenName, itemDescription } = getTaggingInformationScreen(
    history.location.pathname,
    true
  );

  const projectState = useSelector(
    (state: ApplicationState) => state.fabricationProjects
  );

  const [canShowNewProjectModal, setCanShowNewProjectModal] = useState(false);
  const [canShowRevisionOfProjectModal, setCanShowRevisionOfProjectModal] =
    useState(false);

  const [uploadMessage, setUploadMessage] = useState<string>();

  const [uploadedFiles, setUploadedFiles] = useState<RcFile[]>([]);
  const onCloseNewProjectModal = (
    uploadedProjects: number,
    unsendedProjectsFileNames: string[]
  ) => {
    setUploadedFiles([]);
    setCanShowNewProjectModal(false);

    if (uploadedProjects > 0) {
      const message =
        uploadedProjects === 1
          ? `1 arquivo enviado com sucesso.`
          : `${uploadedProjects} arquivos enviados com sucesso.`;
      setUploadMessage(message);
    }

    if (unsendedProjectsFileNames.length > 0) {
      unsendedProjectsFileNames.forEach((fileName) => {
        dispatch(
          addToast({
            type: EToastTypes.WARNING,
            message: `O arquivo: ${fileName} não foi enviado.`,
            durationInMS: 10000,
            analyticsTag: {
              screenName: `${screenName}:Projetos`,
              itemDescription: `${itemDescription}_projetos_errorArquivo${fileName}NaoFoiEnviado`,
              event: 'error',
              itemName: `error:arquivo_${formatTaggingString(
                fileName
              )}_nao_foi_enviado`,
              nonInteraction: true
            }
          })
        );
      });
    }
  };

  const onCloseRevisionOfProjectModal = () => {
    setCanShowRevisionOfProjectModal(false);
    const message = `O arquivo: ${uploadedFiles[0].name} foi enviado com sucesso.`;
    setUploadMessage(message);
  };

  const goToPurchaseFabrication = () => {
    updateProjectsTable();

    dispatch(
      sendTagging({
        screenName: `${screenName}:Projetos`,
        itemDescription: `${itemDescription}_projetos_pedidoDeCompra_pedirCompra`,
        event: 'click',
        itemName: `button:pedir_compra`,
        nonInteraction: true
      })
    );

    history.push(`${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}`);

    dispatch(
      updateFabricationPurchaseOrderSettings({
        ...FABRICATION_ORDER_INITIAL_STATE,
        constructionIdentification: {
          ...FABRICATION_ORDER_INITIAL_STATE.constructionIdentification,
          contractNumber: projectState.contractNumber
        }
      })
    );
  };

  const handleOnFileListChange = (files: RcFile[], isNewProject?: boolean) => {
    setUploadMessage(undefined);
    setUploadedFiles(files);
    if (isNewProject) {
      return setCanShowNewProjectModal(true);
    }
    setCanShowRevisionOfProjectModal(true);
  };

  useEffect(() => {
    if (!uploadMessage) {
      return;
    }
    dispatch(
      addToast({
        message: `${uploadMessage} Deseja fazer um pedido de compra agora?`,
        analyticsTag: {
          screenName: `${screenName}:Projetos`,
          itemDescription: `${itemDescription}_projetos_arquivoEnviadoComSucessoFazerPedido`,
          event: 'success',
          itemName: 'success:arquivo_enviado_com_succeso_fazer_pedido',
          nonInteraction: true
        },
        type: EToastTypes.SUCCESS,
        labelActionTwo: 'Pedir compra',
        handleClickActionTwo: goToPurchaseFabrication
      })
    );
    updateProjectsTable();
  }, [uploadMessage]);

  return (
    <>
      <UploadProjectsContainer
        handleOnFileListChange={handleOnFileListChange}
      />

      {canShowNewProjectModal && projectState.contractNumber && (
        <NewProject
          contractNumber={projectState.contractNumber}
          uploadedFiles={uploadedFiles}
          closeModal={onCloseNewProjectModal}
          handleExistingProject={handleExistingProject}
        />
      )}

      {canShowRevisionOfProjectModal && (
        <RevisionOfProject
          uploadedFile={uploadedFiles[0]}
          projectState={projectState}
          closeModal={onCloseRevisionOfProjectModal}
          onCancel={() => setCanShowRevisionOfProjectModal(false)}
        />
      )}
    </>
  );
};

export default UploadProjects;
